export default {
  id: {
    value: '',
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: '00000000-0000-0000-0000-000000000000'
  },
  regulationAutoID: {
    value: null,
    options: [],
    clearOption: true,
    required: true,
    state: null,
    defaultValue: null
  },
  isFullIndenization: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: false
  },
  valueBodywork: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueTapestry: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valuePainting: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueElectrical: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueMechanical: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueThird: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueGlassware: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  withSuppliedParts: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  withoutSuppliedParts: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueTotalBudgeted: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  valueFranchise: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: 0
  },
  autoTypeID: {
    value: null,
    options: [],
    required: false,
    state: null,
    defaultValue: null
  },
  brandID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: null
  },
  autoModelID: {
    value: null,
    options: [],
    clearOption: true,
    required: false,
    state: null,
    defaultValue: null
  },
  budgetNumber: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: ''
  },
  year: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: ''
  },
  color: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: ''
  },
  plate: {
    value: '',
    maxlength: '10',
    required: false,
    state: null,
    defaultValue: ''
  },
  chassis: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: ''
  },
  hasFrontSuspensionDamage: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: false
  },
  hasRearSuspensionDamage: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: false
  },
  hasEngineDamage: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: false
  },
  hasCoolingSystemsDamage: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: false
  },
  fullIndenization: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: ''
  },
  cnpj: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: ''
  },
  contactName: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: ''
  },
  telephone: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: ''
  },
  observation: {
    value: '',
    maxlength: '50',
    required: false,
    state: null,
    defaultValue: ''
  },
  workshopEmail: {
    value: '',
    maxlength: '100',
    required: false,
    state: null,
    defaultValue: ''
  },
  mechanicalDamageInformation: {
    value: '',
    maxlength: '500',
    required: false,
    state: null,
    defaultValue: ''
  }
}



// WEBPACK FOOTER //
// ./src/views/private/regulation/auto/workshopreturn/sinisterworkshopreturn-form.js